import {assign} from 'lodash';

import {
  LayoutComponent,
  KEYWORD_COMP_LAYOUT_ITEMS,
  KEYWORD_PROP_EXPAND_LAYOUT,
} from './auto_layout_layout_schema';

export class LayoutSingleObjectWrapperLayoutItems {
  constructor(layoutItemsDefinition) {
    assign(this, layoutItemsDefinition);
  }

  getExpandLayout() {
    return this[KEYWORD_PROP_EXPAND_LAYOUT];
  }
}

export class LayoutSingleObjectWrapperComponent extends LayoutComponent {
  constructor(layoutDefinition) {
    super(layoutDefinition);
    assign(this, layoutDefinition);

    this.extendProperties();
  }

  extendProperties() {
    const mine = {};
    assign(mine, this[KEYWORD_COMP_LAYOUT_ITEMS]);
    // extend layoutItems
    this[KEYWORD_COMP_LAYOUT_ITEMS] = new LayoutSingleObjectWrapperLayoutItems(
      this[KEYWORD_COMP_LAYOUT_ITEMS].getRawDataObject()
    );
  }
}

export class LayoutArrayContainerLayoutItems {
  constructor(layoutItemsDefinition) {
    assign(this, layoutItemsDefinition);
  }

  getExpandLayout() {
    return this[KEYWORD_PROP_EXPAND_LAYOUT];
  }
}

export class LayoutArrayContainerComponent extends LayoutComponent {
  constructor(layoutDefinition) {
    super(layoutDefinition);
    assign(this, layoutDefinition);

    this.extendProperties();
  }

  extendProperties() {
    const mine = {};
    assign(mine, this[KEYWORD_COMP_LAYOUT_ITEMS]);
    // extend layoutItems
    this[KEYWORD_COMP_LAYOUT_ITEMS] = new LayoutArrayContainerLayoutItems(
      this[KEYWORD_COMP_LAYOUT_ITEMS].getRawDataObject()
    );
  }
}

export default {
  LayoutSingleObjectWrapperLayoutItems,
  LayoutSingleObjectWrapperComponent,
  LayoutArrayContainerLayoutItems,
  LayoutArrayContainerComponent,
};
